import { useState, useEffect, memo } from "react";
import { useSelector } from "react-redux";
import { useStore } from "reactflow";
import TitlebarTriggerList from "layouts/Flow Designer/components/Titlebar/components/TitlebarActions/TitlebarTriggerList";

const styles = {
  triggerList: {
    width: "max-content",
    borderRadius: "9px",
    position: "absolute",
    top: 0,
    left: "100%",
    marginLeft: "5px",
    zIndex: 1
  }
};

const TriggersList = ({ nodeRef, setNodeStartTriggerListOpen }) => {
  const [scale, setScale] = useState(1);
  const { isVerticalCanvasDirection } = useSelector((state) => state?.designer?.settings);
  const zoomLevel = useStore((store) => store.transform[2]);

  useEffect(() => {
    if (zoomLevel) {
      const inverseScale = 1 / zoomLevel;
      setScale(inverseScale);
    }
  }, [zoomLevel]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (nodeRef.current && !nodeRef.current.contains(event.target)) {
        setNodeStartTriggerListOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <TitlebarTriggerList
      sx={styles.triggerList}
      className={`node-action-trigger-list`}
      executeTriggersList={true}
      setNodeStartTriggerListOpen={setNodeStartTriggerListOpen}
      style={{
        transform: `scale(${scale > 1 ? scale : 1})`,
        position: "fixed",
        transformOrigin: "top left",
        top: isVerticalCanvasDirection ? "60px" : "85px",
        left: isVerticalCanvasDirection ? "70px" : 0
      }}
    />
  );
};

export default memo(TriggersList);
